/*document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 749) return;

  const mediaList = document.querySelector('.product__media-list');
  if (!mediaList) return;

  const items = mediaList.querySelectorAll('.product__media-item');
  if (!items.length) return;

  const itemsArr = Array.from(items);

  
  const ro = new ResizeObserver(entries => {
    for (const entry of entries) {
      const item = entry.target.closest('.product__media-item');
      if (!item) continue;

      const h = entry.contentRect.height;
      if (h > 0) item.style.height = `${h}px`;
    }
  });

  itemsArr.forEach(item => {
    const media =
      item.querySelector('img') ||
      item.querySelector('video') ||
      item.querySelector('model-viewer');

    if (media) ro.observe(media);
  });

  
  function applyVisibleLiHeightToUL() {
    const visibleItem = itemsArr.find(item => item.offsetParent !== null);
    if (!visibleItem) return;

    const h = visibleItem.offsetHeight;
    if (h > 0) mediaList.style.height = `${h}px`;
  }

  
  const prevBtn = document.querySelector('.slider-button--prev');
  const nextBtn = document.querySelector('.slider-button--next');

  function shiftIsActiveLi(forward) {
    let currentIndex = itemsArr.findIndex(item =>
      item.classList.contains('is-active-li')
    );

    if (currentIndex === -1) currentIndex = 0;

    let nextIndex = forward
      ? Math.min(currentIndex + 1, itemsArr.length - 1)
      : Math.max(currentIndex - 1, 0);

    if (nextIndex === currentIndex) return;

    itemsArr[currentIndex].classList.remove('is-active-li');
    itemsArr[nextIndex].classList.add('is-active-li');

    const h = itemsArr[nextIndex].offsetHeight;
    if (h > 0) mediaList.style.height = `${h}px`;
  }

  function onNavClick(isNext) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        applyVisibleLiHeightToUL();
        shiftIsActiveLi(isNext);
      });
    });
  }

  prevBtn?.addEventListener('click', () => onNavClick(false));
  nextBtn?.addEventListener('click', () => onNavClick(true));

  
  itemsArr.forEach(item => item.classList.remove('is-active-li'));
  itemsArr[0].classList.add('is-active-li');
  applyVisibleLiHeightToUL();

  
  window.addEventListener('beforeunload', () => {
    ro.disconnect();
  });
});
*/
document.addEventListener('DOMContentLoaded', () => {

  if (window.innerWidth > 749) return;

  const mediaList = document.querySelector('.product__media-list');
  if (!mediaList) return;

  const items = mediaList.querySelectorAll('.product__media-item');
  if (!items.length) return;

  /* =================================
     1️⃣ ResizeObserver
  ================================== */
  const ro = new ResizeObserver(entries => {
    entries.forEach(entry => {
      const item = entry.target.closest('.product__media-item');
      if (!item) return;

      const h = entry.contentRect.height;
      if (h > 0) item.style.height = h + 'px';
    });
  });

  items.forEach(item => {
    const media = item.querySelector('img') ||
                  item.querySelector('video') ||
                  item.querySelector('model-viewer');
    if (media) ro.observe(media);
  });

  /* =================================
     2️⃣ UL HEIGHT SYNC
  ================================== */
  function updateULHeight(activeItem) {
    if (!activeItem) return;
    const h = activeItem.offsetHeight;
    if (h > 0) mediaList.style.height = h + 'px';
  }

  /* =================================
     3️⃣ ARROW CLICK SUPPORT
  ================================== */
  const prevBtn = document.querySelector('.slider-button--prev');
  const nextBtn = document.querySelector('.slider-button--next');

  function shiftIsActiveLi(forward = true) {
    const currentIndex = Array.from(items).findIndex(item =>
      item.classList.contains('is-active-li')
    );

    let nextIndex = 0;

    if (currentIndex === -1) {
      nextIndex = 0;
    } else {
      if (forward) {
        nextIndex = currentIndex + 1 < items.length
          ? currentIndex + 1
          : currentIndex;
      } else {
        nextIndex = currentIndex - 1 >= 0
          ? currentIndex - 1
          : currentIndex;
      }
    }

    items.forEach(item => item.classList.remove('is-active-li'));
    items[nextIndex].classList.add('is-active-li');

    updateULHeight(items[nextIndex]);
  }

  [prevBtn, nextBtn].forEach(btn => {
    if (!btn) return;

    btn.addEventListener('click', () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          shiftIsActiveLi(btn === nextBtn);
        });
      });
    });
  });

  /* =================================
     4️⃣ MOBILE SWIPE / SCROLL FIX
  ================================== */
  function detectActiveSlideByScroll() {
    const listRect = mediaList.getBoundingClientRect();
    let closestItem = null;
    let smallestDiff = Infinity;

    items.forEach(item => {
      const rect = item.getBoundingClientRect();
      const diff = Math.abs(rect.left - listRect.left);

      if (diff < smallestDiff) {
        smallestDiff = diff;
        closestItem = item;
      }
    });

    if (!closestItem) return;

    items.forEach(item => item.classList.remove('is-active-li'));
    closestItem.classList.add('is-active-li');

    updateULHeight(closestItem);
  }

  let scrollTimeout;
  mediaList.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      detectActiveSlideByScroll();
    }, 60);
  });

  /* =================================
     5️⃣ FIRST LOAD
  ================================== */
  items.forEach(item => item.classList.remove('is-active-li'));
  items[0].classList.add('is-active-li');
  updateULHeight(items[0]);

});